// extracted by mini-css-extract-plugin
export var root = "styles-module--root--2OUcg";
export var button = "styles-module--button--1Wfnk";
export var divider = "styles-module--divider--3_h6p";
export var contentHolder = "styles-module--content-holder--1xRtp";